window.addItem = function addItem(variantId) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ quantity: 1, id: variantId }),
  })
    .then((response) => response.json())
    .then(() => {
      refreshCart();
    });
};

window.clearCart = function clearCart(variantIds, callback) {
  const items = {};
  variantIds.forEach(element => (items[element] = 0));

  return fetch('/cart/update.js', {
    method: 'POST',
    credentials: "same-origin",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates: items })
  })
    .then((response) => response.json())
    .then(() => {
      if (callback) callback();
    })
    .catch(err => console.log(err.responseText || err));
};

let cartData = null;
let cartRequest = null;

function getCart() {
  if (cartRequest) return cartRequest;

  cartRequest = fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      cartData = data;
      return data;
    })
    .catch(error => {
      console.error(error);
    })
    .finally(() => {
      cartRequest = null;
    });

  return cartRequest;
}

window.ShippingBar = function ShippingBar() {
  var speed = 30;
  var items = document.querySelectorAll(".cart-rewards .progress_bar .progress_bar_item");

  items.forEach(function (item) {
    var progressBar = item.querySelector(".cart-rewards .progress");
    if (!progressBar) return;

    var itemValue = progressBar.dataset.progress;

    if (progressBar.classList.contains('progress--no-animate')) {
      progressBar.style.width = itemValue + "%";
    } else {
      var i = 0;

      var count = setInterval(function () {
        if (i <= itemValue) {
          progressBar.style.width = i.toString() + "%";
        } else {
          clearInterval(count);
        }

        if (i >= 100) {
          clearInterval(count);
        }

        i++;
      }, speed);
    }
  });
};

ShippingBar();

window.checkShoppingInsurance = function checkShoppingInsurance() {
  let input_insurance = document.querySelector('.cart-shipping-insurance input');

  if (!input_insurance) return;

  if (input_insurance.dataset.insuranceHandled === 'true') return;
  input_insurance.dataset.insuranceHandled = 'true';

  input_insurance.addEventListener("change", function () {
    if (this.checked === true) {
      addItem(parseInt(this.getAttribute('data-product'), 10));
    } else {
      clearCart([parseInt(input_insurance.getAttribute('data-product'), 10)], function () {
        refreshCart();
      });
    }
  });

  getCart().then(() => {
    if (!cartData) return;

    const item = cartData.items.find(item => item.id === parseInt(input_insurance.getAttribute('data-product'), 10));
    if (item) {
      input_insurance.checked = true;
    }
  });
};

window.checkGiftProduct = function checkGiftProduct(callback) {
  if (!window.giftProduct) return;

  if (window.__checkingGiftProduct) return;
  window.__checkingGiftProduct = true;

  getCart()
    .then(() => {
      if (!cartData) return;

      const item = cartData.items.find(item => item.id === window.giftProduct);

      if (item) {
        if (cartData.item_count === 1 || cartData.total_price === 0) {
          return clearCart([window.giftProduct], callback);
        }
      } else if (cartData.total_price > 0) {
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ quantity: 1, id: window.giftProduct }),
        }).then(() => {
          if (callback) callback();
        });
      }
    })
    .finally(() => {
      window.__checkingGiftProduct = false;
    });
};

window.displayDonationMessageCartDrawer = function displayDonationMessageCartDrawer() {
  getCart()
    .then(cart => {
      if (!cart) return;

      const container = document.querySelector(".movember-container");

      if (container) {
        container.style.display = cart.total_price >= 2000 ? 'flex' : 'none';
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
};

window.addCartNote = function addCartNote() {
  let input_note = document.querySelector('#changeFlavours');
  let addText = '🔄 user agrees to receive a different flavour';

  if (!input_note) return;

  if (input_note.dataset.cartNoteHandled === 'true') return;
  input_note.dataset.cartNoteHandled = 'true';

  function updateCartNote(removeText) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        note: removeText
      })
    });
  }

  getCart()
    .then(() => {
      if (!cartData) return;

      if (cartData.note !== null && cartData.note !== "") {
        input_note.checked = true;
      }
    })
    .then(() => {
      input_note.addEventListener("change", function () {
        if (this.checked === false && document.querySelector('#cartSpecialInstructions')?.value.length > 0) {
          updateCartNote("");
        } else {
          updateCartNote(addText);
        }
      });
    });
};

window.cartSliderFormSubmit = function cartSliderFormSubmit(form, giftProducts) {
  document.querySelectorAll(form).forEach(form => {
    if (form.dataset.cartSliderHandled === 'true') return;
    form.dataset.cartSliderHandled = 'true';

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      if (document.querySelector('.loader-container')) {
        document.querySelector('.loader-container').classList.add('active');
      }

      if (event.submitter) {
        event.submitter.classList.add('working');
      }

      var productSelect = this.querySelector("select");
      if (!productSelect) return;

      var product_id = productSelect.value;

      if (giftProducts === true) {
        window.upsellProductsIDs = window.upsellProductsIDs || [];

        clearCart(window.upsellProductsIDs, function () {
          addItem(product_id);
        });
      } else {
        addItem(product_id);
      }
    });
  });
};

window.cartSliderSelect = function cartSliderSelect(select) {
  document.querySelectorAll(select).forEach(select => {
    if (select.dataset.cartSliderSelectHandled === 'true') return;
    select.dataset.cartSliderSelectHandled = 'true';

    select.addEventListener("change", function (event) {
      event.preventDefault();

      let imgUrl = this.selectedOptions[0].getAttribute('data-upsell-image');
      let variantPrice = this.selectedOptions[0].getAttribute('data-upsell-price');
      let variantComparePrice = this.selectedOptions[0].getAttribute('data-upsell-compare-price');

      if (imgUrl !== 'indefined') {
        const img = this.closest('[data-product-select]')?.querySelector('img');

        if (img) {
          img.src = imgUrl;
          img.srcset = '';
        }
      }

      if (variantPrice !== 'indefined' && this.closest('[data-product-select]')?.querySelector('[data-price] span') !== undefined) {
        this.closest('[data-product-select]').querySelector('[data-price] span').innerText = variantPrice;
      }

      if (variantComparePrice !== 'indefined' && this.closest('[data-product-select]')?.querySelector('[data-price] del') !== undefined) {
        this.closest('[data-product-select]').querySelector('[data-price] del').innerText = variantComparePrice;
      }
    });
  });
};

window.InitSubmit = function InitSubmit() {
  cartSliderFormSubmit(".cart-gift-product form.upsell", true);
  cartSliderSelect(".cart-gift-product form.upsell select");

  if (document.querySelectorAll('[data-delete-gift]') !== undefined) {
    document.querySelectorAll('[data-delete-gift]').forEach(item => {
      if (item.dataset.deleteGiftHandled === 'true') return;
      item.dataset.deleteGiftHandled = 'true';

      var data = {
        id: item.getAttribute('data-delete-gift'),
        quantity: 0
      };

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      })
        .then(() => {
          refreshCart();
        });
    });
  }

  ShippingBar();
  checkShoppingInsurance();
  addCartNote();

  clearTimeout(window.__giftProductCheckTimer);
  window.__giftProductCheckTimer = setTimeout(() => {
    checkGiftProduct();
  }, 600);
};

if (document.querySelector('body.template-cart') !== null) {
  InitSubmit();

  clearTimeout(window.__giftProductCheckTimer);
  window.__giftProductCheckTimer = setTimeout(() => {
    checkGiftProduct();
  }, 600);
}